<template>
  <div>
    <b-modal id="modal-edit" size="lg" centered :title="$store.state.modal.editLembur" header-bg-variant="primary" header-text-variant="light">
      <b-form>
        <b-form-group :label="$store.state.form.namaLembur" label-cols-md="3">
          <b-form-input :state="checkIfValid('namaLembur')" v-model="$v.data.namaLembur.$model" @keydown.enter.prevent="simpan()"></b-form-input>
        </b-form-group>
      </b-form>

      <b-form>
        <b-form-group :label="$store.state.form.nominalLembur" label-cols-md="3">
          <b-form-input
            type="number"
            :state="checkIfValid('nominalLembur')"
            v-model="$v.data.nominalLembur.$model"
            :placeholder="convert(data.nominalLembur)"
            @keydown.enter.prevent="simpan()"
          ></b-form-input>
        </b-form-group>
      </b-form>

      <template #modal-footer>
        <b-button variant="secondary" @click="$bvModal.hide('modal-edit')">
          {{ $store.state.form.batal }}
        </b-button>
        <b-button variant="primary" @click="simpan()" :disabled="!isValid">
          {{ $store.state.form.simpan }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, numeric } from "vuelidate/lib/validators";

export default {
  name: "modalInput",
  props: ["data"],
  data() {
    return {
      selected: null,
      busy: false,
      button: "Simpan",
    };
  },
  computed: {
    formString() {
      return JSON.stringify(this.data, null, 4);
    },
    isValid() {
      return !this.$v.data.$invalid;
    },
    isDirty() {
      return this.$v.data.$anyDirty;
    },
  },
  mixins: [validationMixin],
  validations: {
    data: {
      namaLembur: {
        required,
      },
      nominalLembur: {
        required,
        numeric,
      },
    },
  },
  methods: {
    checkIfValid(fieldName) {
      const field = this.$v.data[fieldName];
      if (!field.$dirty) {
        return null;
      }
      return !(field.$invalid || field.$model === "");
    },
    convert(x) {
      if (x) {
        return x.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      }
    },
    simpan() {
      let vm = this;
      if (vm.isValid) {
        vm.busy = true;
        vm.button = "Mohon Tunggu";
        vm.$axios
          .post("masterLembur/update", vm.data)
          .then((res) => {
            if (res.data.message == "sukses") {
              vm.button = "Simpan";
              vm.busy = false;
              vm.$v.$reset();
              vm.$emit("alertFromChild", {
                variant: "success",
                msg: "BERHASIL MENDAFTARKAN MASTER LEMBUR",
                showing: true,
              });
              this.$bvModal.hide("modal-edit");
            } else {
              vm.button = "Simpan";
              vm.busy = false;
              vm.$emit("alertFromChild", {
                variant: "danger",
                msg: res.data.message.toUpperCase(),
                showing: true,
              });
            }
          })
          .catch((err) => {
            err;
            vm.button = "Simpan";
            vm.busy = false;
            vm.$emit("alertFromChild", {
              variant: "danger",
              msg: "TERJADI KESALAHAN PADA SERVER",
              showing: true,
            });
          });
      }
    },
  },
};
</script>
